<!-- eslint-disable -->
<script setup>
import { useI18n } from 'vue-i18n';
import { useRegisterStore } from '../../stores/register';
import { useCountriesStore } from '../../stores/countries';
import { ref, onMounted, watch } from 'vue';
import _ from 'lodash';

const { t } = useI18n();
const registerStore = useRegisterStore();
const countriesStore = useCountriesStore();
const is_country_ghana = process.env.VUE_APP_COUNTRY == 'GHANA';
const enabled_fields = registerStore.getEnabledRegistrationFields;
const country = ref(null);

let default_country_id = null;

const hasMobileCountryField = () => {
	const fields = registerStore.getEnabledRegistrationFields;
	if (!fields || !fields.length) return true;
	return fields.some(field => field.slug === 'mobile_country_id');
};

const applyCountryPreselection = () => {
	if (is_country_ghana) {
		if (enabled_fields) {
			const country_field = enabled_fields.find(field => field.slug == 'country_id');
			if (country_field) {
				default_country_id = country_field.default_value;
				registerStore.register_input_fields.country_id = country_field.default_value;
			}
		}
		return;
	}

	if (registerStore.register_input_fields.country_id == null) {
		const resolved_region = countriesStore.getResolvedRegion;
		const countries = countriesStore.getCountries;
		
		if (resolved_region && countries && countries.length > 0) {
			const matched_country = countries.find(
				c => c.code && c.code.toUpperCase() === resolved_region.toUpperCase()
			);
			
			if (matched_country) {
				registerStore.register_input_fields.country_id = matched_country.id;
				if (hasMobileCountryField()) {
					registerStore.register_input_fields.mobile_country_id = matched_country.id;
					registerStore.validateMobilePrefix();
				}
			}
		}
	}
};

onMounted(() => {
	applyCountryPreselection();
});

watch(() => countriesStore.getResolvedRegion, () => {
	applyCountryPreselection();
});

watch(() => countriesStore.getCountries, () => {
	applyCountryPreselection();
});

watch(() => registerStore.register_input_fields.country_id, (newValue) => {
	if (newValue != null && hasMobileCountryField()) {
		registerStore.register_input_fields.mobile_country_id = newValue;
		registerStore.validateMobilePrefix();
	}
});

</script>

<template>
<div class="register-form-field">
	<label>{{ $t('account.register.country_of_residence') }} </label>
	<select name="" id="address-country" :style="{ cursor: is_country_ghana ? 'not-allowed' : 'pointer' }" class="form-input form-control" required v-model="registerStore.register_input_fields.country_id" :disabled=is_country_ghana>
		<option :value="null" disabled>{{ $t('account.register.choose_country') }}</option>
		<option v-for="country in countriesStore.getCountries" :key="country.id" :value="country.id">{{ country.name }}</option>
	</select>
	<div class="register-form-list" v-if="registerStore.register_errors.country_id.error && !registerStore.register_input_fields.country_id" >
			<div class="password-meter">
				<div class="password-meter-bar">
					<div class="password-meter-bar-inn"></div>
				</div>
			</div>
			<p>
				<img src="@/assets/svgs/cross.svg" alt=""/>
				&nbsp;
				<span v-if="registerStore.register_errors.country_id.error == 'error_select_country'">
					{{ $t('account.register.error_select_country') }}
				</span>
				<span v-else-if="registerStore.register_errors.hasOwnProperty('country_id')">
					{{ registerStore.register_errors.country_id.error }}
				</span>
			</p>
	</div>
</div>
</template>

<style scoped>
.register-form-main .register-outer-form .register-inner-form .password-meter .password-meter-bar {
	background-color:var(--red);
	margin-bottom:5px;
}
.register-form-main .register-form-list {
	margin-top:unset;
	padding-top:5px;
}
html[dir="rtl"] .register-form-main .register-outer-form .register-inner-form select {
	background-position: 5%;
}
html[dir="rtl"] .register-form-main .register-outer-form .register-inner-form .form-input {
	padding: 10px 15px 10px 15px;
}
</style>
